// extracted by mini-css-extract-plugin
module.exports = {"hyperlink":"hyperlink-DidPE","colored":"colored-B8pH0","no_underline":"no_underline-ZP_NG"};